import { config } from "@/config";
export const ClasificacionMarcaService = {
    async getAll() {
        const response = await fetch(`${config.API_URL}/api/ClasificacionMarca`);
        if (!response.ok)
            throw new Error("Error al obtener clasificaciones de marcas");
        const result = await response.json();
        return result.datos || [];
    },
};
